const __WEBPACK_NAMESPACE_OBJECT__ = rfc6902;